import Service from './service';

export default abstract class Query<Result = void, Param = any> extends Service<Result, Param> {
  readonly = true
}
